import { Injectable, OnInit, Output } from "@angular/core";
import { firstValueFrom, Observable, Subject, Subscription, take } from "rxjs";
import * as Sentry from '@sentry/angular';
import { EstatusJSON } from "../../../../shared/models/EstatusJSON";
import { LocationsAPIService } from "../../../../shared/services/API/LocationsAPI.service";
import { MapHelperService } from "src/services/map-helper.service";
import { environment } from "src/environments/environment";
import { CategoryFiltersDTO } from "../../../../shared/models/CategoryFilters/CategoryFilters";
import { LayerService } from "./Layers.service";
import { LocationDTO } from "../models/LocationDTO";
@Injectable({
  providedIn: "root",
})
export class LocationsService implements OnInit {
  
  setLocationsGeoJsonFilter_Subsbcription: Subscription;
  getGeoJsonAvailabilityFilter_Subsbcription: Subscription;
 
  DataGeoJson$: Subject<EstatusJSON> = new Subject<EstatusJSON>();

  private isLoading: boolean = false;
  private isLoading$: Subject<boolean> = new Subject();

  // mainGeoJsonData: any = null;
  // filterGeoJsonData: any = null;
  // availabilityFilterGeoJsonData: any = null;

  subscription_SetLocationsGeoJSON: Subscription;
  
  constructor(private locationService: LocationsAPIService, private mapHelperService: MapHelperService, private layersService: LayerService) {
  }

  ngOnInit() {
    
  }

  
  setLoading(resp) {
    this.isLoading$.next(resp);
  }

  getLoading() {
    return this.isLoading$.asObservable();
  }


 
  recalculateCoordsProcess() {
    return this.locationService.recalculateCoordsProcess();
  }

  GetGeoJsonFilter(filters: any):any{
    return this.locationService.GetGeoJsonFilter(filters);
  }

  // GetGeoJsonAvailabilityFilter(filters: any, initialDate: string, finalDate: string, idLocationCategories: number[]):any{
  //   this.getGeoJsonAvailabilityFilter_Subsbcription = this.locationService.GetGeoJsonAvailabilityFilter(filters, initialDate, finalDate, idLocationCategories).subscribe({
  //     next: (data)=>{
  //       this.DataGeoJson$.next(data);
  //       this.getGeoJsonAvailabilityFilter_Subsbcription.unsubscribe();
  //     },
  //     error: (error) => {
  //       // TODO marca para complete despues
  //       console.error('Error al obtener el geojson con filtro de disponibilidad', error);
  //       this.getGeoJsonAvailabilityFilter_Subsbcription.unsubscribe();
  //     }
  //   });
  //   return this.DataGeoJson$.asObservable();
  // }

  // async GetLayerGPSGeoJson() {
  //   if(!environment.production) console.log("GetLayerGPSGeoJson");
  //   const data: EstatusJSON = await firstValueFrom(this.layersService.GetLayerGPSGeoJson().pipe(take(1)));
  //   if (data.isSuccess == true) {
  //     this.mainGeoJsonData = JSON.parse(data.result);
  //   } else {
  //     // Sentry.captureMessage('LocationsService.GetLayerGPSGeoJson: respuesta sin éxito', { level: 'warning', extra: { response: data } });
  //   }
  // }

  // async GetLocationsGeoJsonFilter(filters: any[]) {
  //   this.setLoading(true);
  //   if(!environment.production) console.log("GetLocationsGeoJsonFilter");
  //   const data: EstatusJSON = await firstValueFrom(this.GetGeoJsonFilter(filters).pipe(take(1)))
  //   if (data.isSuccess == true) {
  //     this.filterGeoJsonData = JSON.parse(data.result);
  //   } else {
  //     Sentry.captureMessage('LocationsService.GetLocationsGeoJsonFilter: respuesta sin éxito', { level: 'warning', extra: { response: data } });
  //   }
  // }

  // async GetLocationsAvailabilityFilter(filters: any, initialDate: string, finalDate: string, idLocationCategories: number[]) {
  //   this.setLoading(true);
  //   if(!environment.production) console.log("GetLocationsAvailabilityFilterGeoJson");
  //   const data: EstatusJSON = await firstValueFrom(this.GetGeoJsonAvailabilityFilter(filters, initialDate, finalDate, idLocationCategories).pipe(take(1)))
  //   if (data.isSuccess == true) {
  //     this.availabilityFilterGeoJsonData = JSON.parse(data.result);
  //   } else {
  //     Sentry.captureMessage('LocationsService.GetLocationsAvailabilityFilter: respuesta sin éxito', { level: 'warning', extra: { response: data } });
  //   }
  // }

  // paintMainGeoJsonData(geoJson: any): boolean {
  //   this.setLoading(true);
  //   // var pointsSource = this.mapHelperService._map.getSource("pointsSource");
  //   if (geoJson == null || geoJson == undefined )
  //     return false;
  //   try {
  //     if(!environment.production) console.log("updating", geoJson);
  //     this.mapHelperService.UpdateLayerGeoJson("pointsSource", geoJson);
  //     this.setLoading(false);
  //     return true;
  //   } catch (error) {
  //     this.setLoading(false);
  //     return false;
  //   }
  // }

  // paintFilterGeoJsonData(geoJson: any): boolean {
  //   this.setLoading(true);
  //   if (geoJson == null || geoJson == undefined)
  //     return false;
  //   try {
  //     if(!environment.production) console.log("updating", geoJson);
  //     this.mapHelperService.UpdateLayerGeoJson("filterPointsSource", geoJson);
  //     this.setLoading(false);
  //     return true;
  //   } catch (error) {
  //     this.setLoading(false);
  //     return false;
  //   }
  // }

  // resetGeoJsonData() {
  //   this.mainGeoJsonData = null;
  //   this.filterGeoJsonData = null;
  //   this.availabilityFilterGeoJsonData = null;
  // }

  getByIdentifier(identifier): any {
    return this.locationService.getByIdentifier(identifier);
  }
  postValidateIdentifiers(identifiers: string[], client: string = ""): any {
    return this.locationService.postValidateIdentifiers(identifiers, client);
  }

  getLastOdometer(identifier): any {
    return this.locationService.getLastOdometer(identifier);
  }

  updateLocationOdometer( identifier, kilometraje: number): any {
     return this.locationService.updateLocationOdometer(identifier, kilometraje);
  }

  getDataNames(keyNames: any) {
    return this.locationService.getDataNames(keyNames);
  }

  getListByGroups( customerGroups: any ): any {
    return this.locationService.getListByGroups(customerGroups);
  }

  CreateOrUpdateLocationProperty(identifier: string, keyName: string, keyValue: string): any {
    return this.locationService.CreateOrUpdateLocationProperty(identifier, keyName, keyValue);
  }

  createOrUpdateLocation(locationDTO: LocationDTO) {
    return this.locationService.createOrUpdateLocation(locationDTO);
  }

  getList(): any {
    return this.locationService.getList();
  }

  getByClientList(client: string, groupList = "", subGroupList = ""): any {
    return this.locationService.getByClientList(client, groupList, subGroupList);
  }

  findByIdentifier(identifier): any {
    return this.locationService.findByIdentifier(identifier);
  }

  findUpdatedByIdentifier(identifier, tipo): any {
    return this.locationService.findUpdatedByIdentifier(identifier, tipo);
  }

  FindAllByIdentifier(identifier): any {
    return this.locationService.FindAllByIdentifier(identifier);
  }

  getListFilter(filtersRequest : any[]): any {
     return this.locationService.getListFilter(filtersRequest);
  }

  getListFilterTab(filtersRequest : any[], tipoTab: string, finder: string, idLocationCategory: number): any {
     return this.locationService.getListFilterTab(filtersRequest, tipoTab, finder, idLocationCategory);
  }

  GetCountListActualizados(filters: any[]): any {
    return this.locationService.GetCountListActualizados(filters);
  }

  GetCountListDesactualizados(filters: any[]): any {
    return this.locationService.GetCountListDesactualizados(filters);
  }

  GetCountListSinReporte(filters: any[]): any {
    return this.locationService.GetCountListSinReporte(filters);
  }

  GetCountByIdLocationCategory(idLocationCategory:number, filters: any[]) {
    return this.locationService.GetCountByIdLocationCategory(idLocationCategory,filters);
  }

  GetListDesactualizados(): any {
    return this.locationService.GetListDesactualizados();
  }
  GetListByIdLocationCategory(idLocationCategory: number): any {
    return this.locationService.GetListByIdLocationCategory(idLocationCategory);
  }
  
  GetListActualizadosPage(page:number): any {
    return this.locationService.GetListActualizadosPage(page);
  }

  GetListDesactualizadosPage(page:number): any {
    return this.locationService.GetListDesactualizadosPage(page);
  }

  GetListSinReportePage(page:number): any {
    return this.locationService.GetListSinReportePage(page);
  }

  GetListByIdLocationCategoryPage(idLocationCategory: number, page:number, filters: CategoryFiltersDTO[]): any {
    return this.locationService.GetListByIdLocationCategoryPage(idLocationCategory, page, filters);
  }
  
  GetListNamesFilterByIdLocationCategoryPage(idLocationCategory: number, page:number): any {
    return this.locationService.GetListNamesFilterByIdLocationCategoryPage(idLocationCategory, page);
  }

  GetLocationsByPageFilter(zoneId: string, idLocationCategory: number, page:number){
    return this.locationService.GetLocationsByPageFilter(zoneId, idLocationCategory, page);
  }

  GetRouteSheet(parentIdentifier: string, idLocationCategoryChild: number, filter: string, includeGeojson: boolean, orderValue: boolean, isForcedReload: boolean):any{
    return this.locationService.GetRouteSheet(parentIdentifier, idLocationCategoryChild, filter, includeGeojson, orderValue, isForcedReload);
  }

  GetRouteSheetPage(parentIdentifier: string, idLocationCategoryChild: number, filter: string, includeGeojson: boolean, orderValue: boolean, isForcedReload: boolean, page: number):any{
    return this.locationService.GetRouteSheetPage(parentIdentifier, idLocationCategoryChild, filter, includeGeojson, orderValue, isForcedReload, page);
  }

  GetActualizadosGeoJson(){
    return this.locationService.GetActualizadosGeoJson();
  }

  GetDesactualizadosGeoJson(){
    return this.locationService.GetDesactualizadosGeoJson();
  }

  GetSinReporteGeoJson(){
    return this.locationService.GetSinReporteGeoJson();
  }

  GetRouteAB(originLat: string, originLng: string, destinyLat: string, destinyLng: string) {
      return this.locationService.GetRouteAB(originLat, originLng, destinyLat, destinyLng);
  }

}
